document.addEventListener("DOMContentLoaded", () => {
  const gate = document.querySelector("[data-age-gate]");
  const enter = document.querySelector("[data-age-enter]");
  const ageKey = "electrico-age-confirmed";

  if (gate && window.localStorage.getItem(ageKey) === "true") {
    gate.classList.add("is-hidden");
  }

  if (gate && enter) {
    enter.addEventListener("click", () => {
      window.localStorage.setItem(ageKey, "true");
      gate.classList.add("is-hidden");
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-slider]").forEach((slider) => {
    const track = slider.querySelector("[data-slider-track]");
    const slides = Array.from(slider.querySelectorAll("[data-slide]"));
    const dots = Array.from(slider.querySelectorAll("[data-slider-dot]"));
    if (!track || slides.length <= 1) return;

    const delay = (parseInt(slider.dataset.autoplay, 10) || 6) * 1000;
    let index = 0;
    let timer = null;

    const go = (i) => {
      index = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((dot, di) => dot.classList.toggle("is-active", di === index));
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      timer = window.setInterval(() => go(index + 1), delay);
    };

    const prev = slider.querySelector("[data-slider-prev]");
    const next = slider.querySelector("[data-slider-next]");
    if (prev) prev.addEventListener("click", () => { go(index - 1); start(); });
    if (next) next.addEventListener("click", () => { go(index + 1); start(); });
    dots.forEach((dot, di) =>
      dot.addEventListener("click", () => { go(di); start(); })
    );

    slider.addEventListener("mouseenter", stop);
    slider.addEventListener("mouseleave", start);

    go(0);
    start();
  });
});
